// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__1LTRR","header":"ClearentDisclaimer_header__3sFVx","inner":"ClearentDisclaimer_inner__3VGVY"};